// extracted by mini-css-extract-plugin
export default {"stepperContainer":"Register_stepperContainer--Dzq","closeIcon":"Register_closeIcon--_01","closeIconWrapper":"Register_closeIconWrapper--Kic","wrapper":"Register_wrapper--Sb_"};